import { render, staticRenderFns } from "./SottoscrizioniFarmacia.vue?vue&type=template&id=6bbeb236&"
import script from "./SottoscrizioniFarmacia.vue?vue&type=script&lang=js&"
export * from "./SottoscrizioniFarmacia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports